import { Injectable, inject, signal } from '@angular/core';
import { ProblemDetails } from '@features/user-management/user.model';
import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class ApiErrorService {
  private readonly toastService = inject(ToastService);
  readonly currentError = signal<ProblemDetails | null>(null);

  setError(error: ProblemDetails): void {
    this.currentError.set(error);
    const message = formatProblemDetails(error);
    this.toastService.error(message);
  }

  clearError(): void {
    this.currentError.set(null);
  }
}

function formatProblemDetails(problem: ProblemDetails): string {
  const detail = problem.detail?.trim();
  const validationMessage = getFirstValidationMessage(problem.errors);

  if (validationMessage) {
    return `${problem.title}: ${validationMessage}`;
  }

  if (detail) {
    return `${problem.title}: ${detail}`;
  }

  return problem.title;
}

function getFirstValidationMessage(errors: Record<string, string[]> | undefined): string | null {
  if (!errors) {
    return null;
  }

  for (const value of Object.values(errors)) {
    if (!Array.isArray(value)) {
      continue;
    }

    const message = value.find((item) => typeof item === 'string' && item.trim().length > 0);
    if (message) {
      return message;
    }
  }

  return null;
}